import { onePageCheckoutCustom } from "@dana/Store/Pages/OnePageCheckoutExt/OnePageCheckoutReducerExt";
import { ApiHandler,createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<{ orderNotes: string },DispatchProp<onePageCheckoutCustom>>;

export const DispatchSetOrderNotesCustom: HandlerType = props => {
           props.dispatch({
            type: "Pages/OnePageCheckout/SetOrderNotes",
            orderNotes: props.parameter.orderNotes,
        } as any);
};

export const chain = [DispatchSetOrderNotesCustom];

const setOrderNotes = createHandlerChainRunner(chain, "SetOrderNotes");
export default setOrderNotes;
